import React from "react";

const RankIcon = ({icon, extraCSS}) => {
    return (
        <img loading="lazy" src={icon} alt={icon} className={`rank-icon ${extraCSS ? extraCSS : ''}`}/>
    )
}

export default React.memo(RankIcon)
